import React from "react"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme => {
  return {
    keyword: {
      color: theme.palette.green.main
    },
  }
})


export default props => {
  const classes = useStyles(props)
  const {children, keywords: keywordsProp, ...otherProps} = props

  if (typeof children !== 'string') {
    throw new Error("props.children is not a string")
  }

  const extractKeywords = (text, keywords) => {
    let splitText = [text]
    for (let keyword of keywords) {
      const newSplit = []
      for (let fragment of splitText) {
        const keywordSplit = fragment.split(keyword)
        if (keywordSplit.length > 1) {
          for (let i = 0; i < keywordSplit.length - 1; i++) {
            newSplit.push(keywordSplit[i], keyword)
          }
        }
        newSplit.push(keywordSplit[keywordSplit.length - 1])
      }
      splitText = newSplit
    }
    
    return splitText.map((fragment, i) => {
      let className
      if (keywords.includes(fragment)) {
        className=classes.keyword
      }
      return <span key={i} className={className}>{fragment}</span>
    })
  }

  return (
    <Typography {...otherProps}>
      {extractKeywords(children, keywordsProp)}
    </Typography>
  )
}
